import React from "react";
import Tabs from "../Tabs/Tabs";
import ModalHeader from "../ModalButtons/ModalHeader";
import ModalButtons from "../ModalButtons/ModalButtons";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
// import TaskManagerPresenterTabs from "./TaskManagerPresenterTabs"
import TaskManagerPresenterWorkspace from "./TaskManagerPresenterWorkspace";

class TaskManagerPresenter extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      active_tab: "general",
      loading: false,
      errors: this.props.errors ? this.props.errors : {},
      task_update_path: this.props.task_update_path,

      /* fields */
      rake_task_name: this.props.rake_task_name,
      time_period: this.props.time_period,
      time_value: this.props.time_value,
      time_format: this.props.time_format,
      status: this.props.status,
    };

    this.setActiveTab = this.setActiveTab.bind(this);
  }

  render() {
    var buttons = [
      {
        name: I18n.t("ok"),
        html_attributes: ['data-dismiss="modal"'],
      },
    ];
    return (
      <div className="TaskManagerPresenter">
        <Tabs tabs={this.tabs()} />
        <div className="panel panel-form">
          <ModalHeader helpText="room_types_users_guide" />
          <ModalButtons loading={this.state.loading} buttons={buttons} />
          <TaskManagerPresenterWorkspace {...this.state} />
        </div>
        <LoadingSpinner show={this.state.loading} />
      </div>
    );
  }

  tabs() {
    var tabs = [];

    tabs.push({
      tabName: I18n.t("general"),
      targetName: "general",
      classes: this.state.active_tab === "general" ? "active" : null,
      changeHandler: this.setActiveTab,
    });

    return tabs;
  }

  setActiveTab(tab) {
    this.setState({
      active_tab: tab,
    });
  }
}

export default TaskManagerPresenter;
